<template>
  <div id="cta" class="container">
    <div class="cta-wrap style2 ptb-100 bg-f">
      <div class="row align-items-center">
        <div class="col-lg-7 col-md-10">
          <div class="content-title style3">
            <span>Call To Action</span>
            <h2>
              Feel Free <span>To Contact Us</span> To Get Our Telehealth Medical
              Services
            </h2>
            <a href="tel:598654324" class="btn style2">
              Call Us(+5984 654 324)
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CallToAction",
};
</script>